<script lang="ts">
    
</script>

<div class="map-alert alert mw-50">
    <div class="map-alert-content">
        <slot />
    </div>
</div>
